var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: _vm.loading, width: "478" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _vm.brandList.length > 0
                ? _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            ripple: false,
                            color: "error",
                            depressed: "",
                            rounded: "",
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v(" mdi-delete-outline "),
                      ]),
                      _vm._v(
                        " ลบแบรนด์ (" + _vm._s(_vm.brandList.length) + ") "
                      ),
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        { attrs: { ripple: false, color: "error", icon: "" } },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v(" mdi-delete-outline ")])],
                    1
                  ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "p-5" },
        [
          _c(
            "v-card-title",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "#A9A9A9", "x-small": "", icon: "" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogs()
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(" mdi-close "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                { staticClass: "d-flex align-center justify-center mb-3" },
                [
                  _c(
                    "v-icon",
                    { attrs: { color: "error", size: "60", center: "" } },
                    [_vm._v(" $snt_trash ")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "text-center mt-4" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "subtitle-1 secondary--text font-weight-medium",
                  },
                  [
                    _vm.brandId
                      ? _c("span", [
                          _vm._v(
                            " คุณต้องการลบแบรนด์ " +
                              _vm._s(_vm.brandName) +
                              "? "
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            " คุณต้องการลบแบรนด์จำนวน (" +
                              _vm._s(_vm.brandList.length) +
                              ") ชิ้น? "
                          ),
                        ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "subtitle-2 grey--text font-weight-regular" },
                  [_vm._v(" แบรนด์ในสินค้าทั้งหมดจะถูกลบด้วย ")]
                ),
              ]),
              _c("v-divider", { staticClass: "mt-8" }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    disabled: _vm.loading,
                    rounded: "",
                    text: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogs()
                    },
                  },
                },
                [_vm._v(" ยกเลิก ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    height: "40",
                    elevation: "0",
                    color: "error",
                    ripple: false,
                    loading: _vm.loading,
                    disabled: _vm.loading,
                    rounded: "",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit()
                    },
                  },
                },
                [_vm._v(" ยืนยันลบข้อมูล ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }